import { StyleSheet } from "react-native";
import { AppTheme } from "../../../theme";

export const readymadeProductsStyle = (theme: AppTheme) => StyleSheet.create({
    containerView: {
        flex: 1,
        backgroundColor: "#f8f8f8"
    },
    searchContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginHorizontal: 10,
        gap: 10,
        marginVertical: 8,
        alignItems: "center"
    },
    searchBarWrapper: {
        flex: 1
    },
    headerRightContainer: {
        flexDirection: "row",
        alignItems: "center",
        flex: 0.3
    },
    searchBarContainer: {
        backgroundColor: theme.light,
        paddingHorizontal: 10,
        borderRadius: 20,
        height: 48,
        borderBottomWidth: 0,
        borderTopWidth: 0
    },
    searchInput: {
        color: theme.lightDark,
        fontSize: theme.smallFontSize,
        fontFamily: theme.medium,
        paddingLeft: 15
    },
    renderItemContainer: {
        marginBottom: 10,
        marginHorizontal: 10,
        elevation: 1,
        padding: 10,
        borderRadius: 13,
        backgroundColor: theme.light,
        borderColor: theme.primary
    },
    itemInnerRow: {
        flex: 1,
        justifyContent: "space-between",
        flexDirection: "row"
    },
    itemLeftCol: {
        flex: 1,
        columnGap: 10,
        flexDirection: "row",
        alignItems: "center"
    },
    itemImageRow: {
        flex: 1,
        paddingVertical: 10,
        flexDirection: "row",
        alignItems: "flex-start",
        columnGap: 10
    },
    itemImage: {
        width: 70,
        height: 80
    },
    itemDetailContainer: {
        flex: 1,
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between"
    },
    itemTextContainer: {
        rowGap: 7
    },
    listFooterLoader: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    selectAllHeader: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 10
    },
    selectAllLeft: {
        paddingHorizontal: 10,
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    checkBoxContainer: {
        margin: 0,
        padding: 0,
        backgroundColor: "transparent"
    },
    optionContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    optionInnerContainer: {
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: theme.lightBackgroundColor,
        padding: 5,
        borderRadius: 5
    },
    optionTextStyle: {
        fontSize: theme.smallFontSize,
        fontFamily: theme.bold,
        marginLeft: 5
    },
    dropdownContainer: {
        height: 48
    }
})
